export class PaScheduledInfoModal {
    scheduleId :string;
    eaCaseId:string;
    caseType:string;
    date :string;
    roomName :string;
    surgeonName :string;
    assistantName :string;
    anethesia :string;
    refferedBy :string;
    indication :string;
    height:string;
    weight:string;
    fever :string;
    bloodPressure :string;
    glucose :string;
    pulseRate :string;
    reasonOfVisit :string;
}
